import axios from "../http";

let module = "/sysUser";

function addUserBase(data) {
    return axios.post(module + '/addUserBase', data);
}

function selectUserBySearch(data) {
    return axios.post(module + '/selectUserBySearch', data);
}

function updateUserWork(data) {
    return axios.post(module + '/updateUserWork', data);
}

function updateUserLenable(data) {
    return axios.post(module + '/updateUserLenable', data);
}

function deleteUser(data) {
    return axios.post(module + '/deleteUser', data);
}

function resetPassword(data) {
    return axios.post(module + '/resetPassword', data);
}

function modifyPassword(data) {
    return axios.post(module + '/modifyPassword', data);
}

function saveUserDetail(data) {
    return axios.post(module + '/saveUserDetail', data);
}

function getUserInfo(data) {
    return axios.post(module + '/getUserInfo', data);
}

function passwordVerification(data) {
    return axios.post(module + '/passwordVerification', data);
}

function modifyUserPassword(data) {
    return axios.post(module + '/modifyUserPassword', data);
}


export default {
    addUserBase,
    selectUserBySearch,
    updateUserWork,
    updateUserLenable,
    deleteUser,
    saveUserDetail,
    getUserInfo,
    resetPassword,
    modifyPassword,
    passwordVerification,
    modifyUserPassword,
}
